import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import RolexWatchComponent from './js/rolex-watch.component';

ComponentsFactory.getInstance().define('rolex-watch', RolexWatchComponent);
